var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoCourts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-20-22h1150v754H-20z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.617 108c.316-.416.42-.953.275-1.458l-2.517-9c-.2-.72-.854-1.22-1.604-1.22h-2l-2.284-8.213a1.673 1.673 0 0 0-1.608-1.22h-1.996V55.421h1.996c.921 0 1.667-.75 1.667-1.667v-6.363c0-.92-.75-1.666-1.667-1.666H84.154c-.92 0-1.666.75-1.666 1.666v6.363c0 .92.75 1.667 1.666 1.667h2.434v31.466h-11.63a1.7 1.7 0 0 0-.387-.046h-1.996v-31.42h1.992c.92 0 1.666-.75 1.666-1.667v-6.363c0-.92-.75-1.666-1.666-1.666H54.846c-.921 0-1.667.75-1.667 1.666v6.363c0 .92.75 1.667 1.667 1.667h2.425v31.42h-2.425c-.13 0-.259.017-.375.046H43.158V55.422h1.996c.921 0 1.667-.75 1.667-1.667v-6.363c0-.92-.75-1.666-1.667-1.666H25.425c-.92 0-1.667.75-1.667 1.666v6.363c0 .92.75 1.667 1.667 1.667h2.425v31.466h-2.425c-.67 0-1.28.409-1.538 1.025l-3.512 8.409h-2.167c-.75 0-1.404.5-1.608 1.22l-2.504 9a1.676 1.676 0 0 0 .279 1.459c.312.416.804.658 1.325.658h96.583c.53 0 1.021-.242 1.334-.658zM85.825 49.064h16.392v3.03H85.829v-3.03h-.004zm4.104 6.363h8.625v31.466H89.93V55.426zm-33.416-6.363h16.391v3.03H56.512v-3.03zm4.095 6.363h8.634v31.466h-8.634V55.426zm-29.42 31.466V55.426h8.633v31.466h-8.633zm-4.092-37.829h16.396v3.03H27.095v-3.03zm-.558 41.163h76.083l1.696 6.096H23.992l2.545-6.096zm-8.634 15.096l1.575-5.663H108.513l1.583 5.663H17.904z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.517 18.9a1.635 1.635 0 0 0-1.409 0L16.063 40.843a1.675 1.675 0 0 0-.963 1.513v4.925c0 .92.75 1.667 1.667 1.667H110.8c.92 0 1.667-.75 1.667-1.667v-4.946c0-.646-.38-1.237-.963-1.508L64.517 18.9zm44.616 26.71H18.438v-2.193l45.379-21.166 45.32 21.146v2.212h-.004z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCourts);
export default __webpack_public_path__ + "static/media/ico-courts.5a8aa8733a795228d8fb35e45014c017.svg";
export { ForwardRef as ReactComponent };